import { updateObject } from '../../ObjectTools';
import * as Constants from '../../Constants';

export const getImageStyle = (settings) => {
    // Image-Settings
    let imgStyle = {};
    switch (settings.type) {
        case Constants.IMGTYPE_BACKGROUND:
            if (settings.background) {
                const bg = settings.background;
                if (bg.origin) {
                    imgStyle = updateObject(imgStyle, getPosition(bg.origin));
                }
            }
            break;
        default:
            console.log('invalid settings-type');
    }
    return imgStyle;
}

// const getFloat = (float) => {
//     switch (float) {
//         case Constants.LOCATION_LEFT:
//             return { float: 'left', clear: 'right' };
//         case Constants.LOCATION_RIGHT:
//             return { float: 'right', clear: 'left' };
//         default:
//             return null;
//     }
// }

const getPosition = (pos) => {
    if (!pos) return null;

    // Split "Bottom 10px" to ["Bottom", "10px"]
    const [base, offset] = pos.split(' ');

    const offsetValue = offset ? ` ${offset}` : '';

    switch (pos) {
        case Constants.LOCATION_TOP_LEFT:
            return { backgroundPosition: `top left${offsetValue}` };
        case Constants.LOCATION_TOP:
            return { backgroundPosition: `top${offsetValue}` };
        case Constants.LOCATION_TOP_RIGHT:
            return { backgroundPosition: `top right${offsetValue}` };
        case Constants.LOCATION_LEFT:
            return { backgroundPosition: `left${offsetValue}` };
        case Constants.LOCATION_CENTER:
            return { backgroundPosition: `center${offsetValue}` };
        case Constants.LOCATION_RIGHT:
            return { backgroundPosition: `right${offsetValue}` };
        case Constants.LOCATION_BOTTOM_LEFT:
            return { backgroundPosition: `bottom left${offsetValue}` };
        case Constants.LOCATION_BOTTOM:
            return { backgroundPosition: `bottom${offsetValue}` };
        case Constants.LOCATION_BOTTOM_RIGHT:
            return { backgroundPosition: `bottom right${offsetValue}` };
        default:
            return null;
    }
}